import React from "react";
import { Link } from "react-router-dom";
import {
  Building2, TrendingUp, ShieldCheck, BadgeCheck, Lock, ArrowRight,
} from "lucide-react";
import { SectionHeader, Pill } from "./_shared";

export default function MarketplacePreview() {
  const cards = [
    {
      name: "GreenGrid Energy Pvt Ltd", sector: "CleanTech · Seed · Delhi NCR",
      ask: "₹5 Cr", rev: "₹25L–₹50L ARR",
      trust: 82, trustLabel: "Investor Ready", match: 92,
      badges: ["Company Verified", "Health Check Available", "DD Pending"],
      tone: "emerald",
    },
    {
      name: "FinEdge Analytics Pvt Ltd", sector: "Fintech · Pre-Series A · Bengaluru",
      ask: "₹12 Cr", rev: "₹2Cr–₹3Cr ARR",
      trust: 88, trustLabel: "Investor Ready", match: 89,
      badges: ["Company Verified", "Financials Admin Verified", "DD Available"],
      tone: "emerald",
    },
    {
      name: "MedNova Devices Pvt Ltd", sector: "HealthTech · Seed · Pune",
      ask: "₹7 Cr", rev: "Pilot Stage",
      trust: 71, trustLabel: "Almost Ready", match: 81,
      badges: ["Manual Verification Pending", "Health Check In Progress"],
      tone: "gold",
    },
  ];
  return (
    <section className="py-16 lg:py-20 bg-white" data-testid="marketplace-preview-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          eyebrow="VERIFIED MARKETPLACE"
          title="Explore diligence-backed private-market opportunities."
          subtitle="Each opportunity can carry verification badges, confidence labels, readiness scores, and controlled investor access."
        />
        <div className="grid md:grid-cols-3 gap-5">
          {cards.map((c, i) => (
            <div key={c.name} className="rounded-lg border border-navy/10 bg-cream/50 p-5 hover:border-gold hover:shadow-xl hover:-translate-y-0.5 transition-all" data-testid={`marketplace-card-${i + 1}`}>
              <div className="flex items-center justify-between mb-2">
                <Pill tone="light"><Building2 size={10} /> {c.sector.split(" · ")[0]}</Pill>
                <div className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-navy text-cream text-[10px] font-mono">
                  <TrendingUp size={9} /> Match {c.match}
                </div>
              </div>
              <div className="font-heading text-lg text-ink leading-tight">{c.name}</div>
              <div className="text-[11px] font-mono uppercase tracking-wider text-ink-muted mt-1">{c.sector}</div>

              <div className="grid grid-cols-2 gap-3 mt-4">
                <div>
                  <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted">Funding Ask</div>
                  <div className="font-mono text-ink">{c.ask}</div>
                </div>
                <div>
                  <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted">Revenue</div>
                  <div className="font-mono text-ink text-sm">{c.rev}</div>
                </div>
              </div>

              <div className="mt-4 rounded border border-gold/40 bg-gold/[0.05] p-3 flex items-center justify-between">
                <div>
                  <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-gold">VENTURAZ Trust</div>
                  <div className="font-heading text-2xl text-ink leading-none mt-1">{c.trust}<span className="text-[11px] text-ink-muted font-mono">/100</span></div>
                </div>
                <div className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-mono border ${c.tone === "emerald" ? "bg-emerald-50 border-emerald-300 text-emerald-700" : "bg-gold/20 border-gold/40 text-[#8A6600]"}`}>
                  <ShieldCheck size={10} /> {c.trustLabel}
                </div>
              </div>

              <div className="flex flex-wrap gap-1.5 mt-3">
                {c.badges.map((b) => (
                  <span key={b} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-white border border-navy/10 text-[10px] font-mono uppercase tracking-wider text-ink-soft">
                    <BadgeCheck size={9} className="text-gold" /> {b}
                  </span>
                ))}
              </div>

              <div className="mt-4 flex items-center justify-between text-[11px] font-mono">
                <div className="inline-flex items-center gap-1 text-ink-muted">
                  <Lock size={10} /> Sensitive data locked
                </div>
                <Link to="/marketplace" className="inline-flex items-center gap-1 text-gold hover:text-[#8A6600] uppercase tracking-wider" data-testid={`marketplace-card-cta-${i + 1}`}>
                  View Profile <ArrowRight size={11} />
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-6 text-center">
          <Link to="/marketplace" className="inline-flex items-center gap-2 bg-navy text-cream px-5 py-2.5 rounded-md font-heading text-sm hover:bg-[#256E58] transition-colors" data-testid="marketplace-preview-cta">
            Explore Verified Directory <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
